var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7640",
    "data-name": "Group 7640",
    transform: "translate(-1770 -110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6678",
    "data-name": "Rectangle 6678",
    width: 50,
    height: 50,
    rx: 6,
    transform: "translate(1770 110)",
    fill: "#e5e8eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "filter",
    transform: "translate(1785 126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0-1H20a1,1,0,0,1,.907.579A1,1,0,0,1,20.764.646L13,9.826V18a1,1,0,0,1-1.447.894l-4-2A1,1,0,0,1,7,16V9.826L-.764.646A1,1,0,0,1-.907-.421,1,1,0,0,1,0-1ZM17.845,1H2.155L8.764,8.814A1,1,0,0,1,9,9.46v5.922l2,1V9.46a1,1,0,0,1,.236-.646Z",
    fill: "#242424"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.e4d683a79e9e0cd80e18645d8a5f42b2.svg";
export { ForwardRef as ReactComponent };